import AllArticles from "./AllArticles"
import PaginationArticles from "./PaginationArticles"
import { useLocation } from "react-router-dom"
import { Paper } from "@mui/material"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const MainArticlePage = () => {
  const query = useQuery()
  const page = query.get("page") || 1
  return (
    <>
      <AllArticles />
      <Paper elevation={6} sx={{ marginY: 2 }}>
        <PaginationArticles page={page} />
      </Paper>
    </>
  )
}
export default MainArticlePage
